import GraduateProfile from './GraduateProfile';

export default GraduateProfile;